module.exports = __webpack_public_path__ + "img/GOOGLE.4dc2b756.png";